var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesignServices = function SvgDesignServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.046 11.263 2.217-2.233-1.727-1.743-1.129 1.13-1.054-1.054 1.114-1.13-1.539-1.538-2.232 2.233zm8.017 8.032 2.233-2.233-1.539-1.538-1.129 1.113-1.053-1.053 1.113-1.13-1.733-1.717-2.217 2.218zm-9.77 1.114H3.593v-3.702l4.385-4.385-5.385-5.394L6.928 2.59l5.42 5.41 4.12-4.137a1.52 1.52 0 0 1 1.095-.455q.305 0 .582.111.28.113.512.344l1.479 1.524q.232.232.34.511a1.6 1.6 0 0 1 0 1.153 1.5 1.5 0 0 1-.34.499l-4.102 4.127 5.375 5.394-4.336 4.337-5.395-5.385zm-2.201-1.5h1.563l9.81-9.795-1.579-1.578-9.794 9.81zM15.688 8.328l-.802-.792 1.579 1.578z"
  })));
};
export default SvgDesignServices;